// @flow
import { FormattedMessage, FormattedNumber } from 'react-intl';
import classNames from 'classnames';
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faFire } from '@fortawesome/pro-solid-svg-icons/faFire';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faPauseCircle } from '@fortawesome/pro-regular-svg-icons/faPauseCircle';
import { faVideo } from '@fortawesome/pro-solid-svg-icons/faVideo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styles from './ConsoleSocial.module.scss';

type Props = {
    bidders: number,
    className?: string,
    hasVideo?: boolean,
    isOnCatalogCard?: boolean,
    isPaused?: boolean,
    saves?: number,
    trending?: boolean,
};

const ConsoleSocial = (props: Props) => {
    const {
        bidders = 0,
        className = '',
        hasVideo = false,
        isOnCatalogCard = false,
        isPaused = false,
        saves = 0,
        trending = false,
    } = props;

    const liveStyles = classNames(styles['live-container'], {
        [styles['red-container']]: isOnCatalogCard,
        [styles['text-on-console-live']]: isPaused,
    });
    const eyeStyles = classNames(styles['eye-container'], {
        [styles['black-container']]: isOnCatalogCard,
        [styles['text-on-console-eye']]: isPaused,
    });
    const classes = classNames(styles.social, className, { [styles.column]: !isOnCatalogCard });

    return (
        <div className={classes}>
            <div>
                {(isOnCatalogCard || isPaused) && (
                    <div className={liveStyles}>
                        <span className={styles.live}>
                            {hasVideo && <FontAwesomeIcon icon={faVideo} className={styles.video} />}
                            {isPaused && <FontAwesomeIcon icon={faPauseCircle} className={styles.pause} />}
                            {isPaused ? <FormattedMessage id="paused" /> : <FormattedMessage id="live" />}
                        </span>
                    </div>
                )}
                <div className={eyeStyles}>
                    {trending ? (
                        <FontAwesomeIcon icon={faFire} className={styles.fire} />
                    ) : (
                        <FontAwesomeIcon icon={faEye} className={styles.eye} />
                    )}
                    <span>
                        <FormattedNumber maximumFractionDigits={0} minimumFractionDigits={0} value={bidders || 1} />
                    </span>
                </div>
            </div>
            {saves && !isOnCatalogCard ? (
                <div className={styles['heart-container']}>
                    <FontAwesomeIcon icon={faHeart} className={styles.heart} />
                    <span>
                        <FormattedNumber maximumFractionDigits={0} minimumFractionDigits={0} value={saves} />
                    </span>
                </div>
            ) : null}
        </div>
    );
};

export default React.memo<Props>(ConsoleSocial);
